import { useT } from "@/lib/i18n";
import { fmtLap, lapTag } from "@/lib/laps";

const th = "px-3 py-2.5 text-left whitespace-nowrap";
const td = "px-3 py-1.5 whitespace-nowrap";

export const LapTable = ({ data, stats, prefix = "lap" }) => {
  const { t } = useT();
  const p = data.precision;
  return (
    <div data-testid={`${prefix}-table`} className="bg-[#12141C] border border-[#282D3D] rounded-sm overflow-x-auto">
      <table className="w-full font-mono text-xs sm:text-sm">
        <thead className="text-[10px] uppercase tracking-wider text-slate-500 bg-[#090A0F]">
          <tr>
            <th className={th}>{t("lap_col")}</th>
            <th className={th}>{t("time_col")}</th>
            <th className={th}>{t("gap_best")}</th>
            {data.sector_names.map((s) => <th key={s} className={th}>{s}</th>)}
            {data.param_names.map((n) => <th key={n} className={th}>{n}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.laps.map((l, i) => {
            const tag = lapTag(data, i);
            const isBest = stats.best && l === stats.best;
            return (
              <tr key={`${l.lap}-${i}`} data-testid={`${prefix}-row-${l.lap}`} data-best={isBest ? "true" : "false"}
                className={`border-t border-[#282D3D]/60 border-l-2 ${isBest ? "bg-[#10B981]/10 border-l-[#10B981]" : "border-l-transparent"} ${tag ? "opacity-45" : ""}`}>
                <td className={td}>{l.lap}{tag && <span className="ml-1.5 text-[9px] text-[#FFB800]">{tag}</span>}</td>
                <td className={`${td} font-bold ${isBest ? "text-[#10B981]" : "text-white"}`}>{fmtLap(l.time, p)}</td>
                <td className={`${td} text-slate-400`}>{l.valid && stats.best ? (l.time - stats.best.time === 0 ? "—" : `+${(l.time - stats.best.time).toFixed(p)}`) : ""}</td>
                {l.sectors.map((s, si) => {
                  const bestSec = l.valid && s === stats.bestSectors?.[si];
                  return <td key={si} className={`${td} ${bestSec ? "text-[#A855F7] font-bold" : ""}`}>{s ? fmtLap(s, p) : "—"}</td>;
                })}
                {data.param_names.map((n) => <td key={n} className={`${td} text-slate-300`}>{l.params[n] ?? "—"}</td>)}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
